export default "__VITE_ASSET__BnRrknk7__"